import React from 'react'
import { Field } from 'formik'

import {
  Options,
} from './styles'
import IField from '../../../../interfaces/field'
import TplGroup from '../tpl-group'

type IProps = any & IField

const InputRadio = ({
  title,
  required = false,
  name,
  prefixName = '',
  options,
  ...el
}: IProps) => (
  <TplGroup
    name={`${prefixName}${name}`}
    prefixName={prefixName}
    title={title}
    required={required}
    {...el}
  >
    <Options>
      {
        options.map((option: { label: string, value: any }) => (
          <div key={option.label}>
            <Field
              type="radio"
              name={`${prefixName}${name}`}
              value={String(option.value)}
              required={required}
              disabled={el?.disabled === true}
            />
            <span>{option.label}</span>
          </div>
        ))
      }
    </Options>
  </TplGroup>
)

export default InputRadio
